import React, { useState,useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/about.css";
import AOS from "aos";
import "aos/dist/aos.css";  

const AboutAccordionSection = () => {
      useEffect(() => {
    AOS.init({
      duration: 1000,   
      easing: "ease-in-out",       
    });
  }, []);
  const [activeIndex, setActiveIndex] = useState(0);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const renderIcon = (index) => {
    return activeIndex === index ? "−" : "+";
  };

  return (
    <section className="about-accordion-section" data-aos="fade-up"  data-aos-delay="100">
      <div className="container-fluid">
        <div className="row align-items-center">

          {/* LEFT IMAGE BOX */}
          <div className="col-lg-6 mb-4 mb-lg-0">
            <div className="about-image-box">
              <h2>Trusted Legal Expertise</h2>
              <p>Delivering excellence, integrity & client-focused solutions</p>
            </div>
          </div>

          {/* RIGHT ACCORDION */}
          <div className="col-lg-6">

            {/* ITEM 1 */}
            <div className="accordion-item">
              <button
                className="accordion-button-custom"
                onClick={() => toggleAccordion(0)}
              >
                <span>Who We Are</span>
                <span className="accordion-icon">{renderIcon(0)}</span>
              </button>

              {activeIndex === 0 && (
                <div className="accordion-body">
                  We are a leading national law firm with a strong presence
                  across India, advising corporates, financial institutions,
                  government bodies, and multinational clients on complex
                  legal and regulatory matters.
                </div>
              )}
            </div>

            {/* ITEM 2 */}
            <div className="accordion-item">
              <button
                className="accordion-button-custom"
                onClick={() => toggleAccordion(1)}
              >
                <span>Our Management Structure</span>
                <span className="accordion-icon">{renderIcon(1)}</span>
              </button>

              {activeIndex === 1 && (
                <div className="accordion-body">
                  Our firm follows a transparent, partner-led management
                  structure governed by an elected executive committee,
                  ensuring accountability and collaboration.
                </div>
              )}
            </div>

            {/* ITEM 3 */}
            <div className="accordion-item">
              <button
                className="accordion-button-custom"
                onClick={() => toggleAccordion(2)}
              >
                <span>Why Clients Choose Us</span>
                <span className="accordion-icon">{renderIcon(2)}</span>
              </button>

              {activeIndex === 2 && (
                <div className="accordion-body">
                  Clients value our deep sector expertise, practical legal
                  advice, and ability to combine large-firm strength with
                  boutique responsiveness.
                </div>
              )}
            </div>

            {/* ITEM 4 */}
            <div className="accordion-item">
              <button
                className="accordion-button-custom"
                onClick={() => toggleAccordion(3)}
              >
                <span>Our Core Values</span>
                <span className="accordion-icon">{renderIcon(3)}</span>
              </button>

              {activeIndex === 3 && (
                <div className="accordion-body">
                  Integrity, collaboration, continuous learning, and strong
                  client commitment guide everything we do.
                </div>
              )}
            </div>

            {/* ITEM 5 */}
            <div className="accordion-item">
              <button
                className="accordion-button-custom"
                onClick={() => toggleAccordion(4)}
              >
                <span>Client-Centric Approach</span>
                <span className="accordion-icon">{renderIcon(4)}</span>
              </button>

              {activeIndex === 4 && (
                <div className="accordion-body">
                  Our lawyers work seamlessly across practice areas and
                  offices to deliver tailored, business-focused solutions.
                </div>
              )}
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutAccordionSection;
